import { useCallback, useState } from 'react';
import { createProvider } from '../../libs/component-logic/createProvider';

export type BannerState = {
  resetBanner: () => void;
  revertBanner: () => void;
  bannerShown: boolean;
  bannerText: string;
  bannerHeight: number;
  setBannerHeight: (bannerHeight: number) => void;
};

const { Provider: BannerStateProvider, useValue: useBanner } = createProvider<BannerState>(
  undefined,
  'BannerStateProvider'
);

type BannerProviderProps = { children: React.ReactNode; bannerShown: boolean; bannerText?: string };

export const BannerProvider = ({
  children,
  bannerShown = false,
  bannerText = '',
}: BannerProviderProps) => {
  const [bannerState, setBannerState] = useState(bannerShown);
  const [bannerHeight, setBannerHeight] = useState(0);

  const resetBanner = useCallback(() => {
    setBannerState(false);
    setBannerHeight(0);
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const revertBanner = useCallback(() => setBannerState(bannerShown), []);

  return (
    <BannerStateProvider
      {...{
        value: {
          bannerShown: bannerState,
          resetBanner,
          revertBanner,
          bannerHeight,
          setBannerHeight,
          bannerText,
        },
      }}>
      {children}
    </BannerStateProvider>
  );
};

export { useBanner };
